import { Inject, Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfig } from '@cardapio-online/config';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
  constructor(@Inject(APP_CONFIG) private readonly cfg: AppConfig) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const isAbsolute = /^https?:\/\//i.test(req.url);
    const base = (this.cfg.apiBaseUrl ?? '').trim();
    const tenantSlug = (this.cfg.tenantSlug ?? '').trim();

    const url =
      isAbsolute || !base
        ? req.url
        : `${base}${req.url.startsWith('/') ? '' : '/'}${req.url}`;

    const setHeaders: Record<string, string> = {};
    const shouldAttachTenantHeader =
      !!tenantSlug &&
      !req.headers.has('X-Tenant-Slug') &&
      (!isAbsolute || (!!base && req.url.startsWith(base)));

    if (shouldAttachTenantHeader) {
      setHeaders['X-Tenant-Slug'] = tenantSlug;
    }

    if (url === req.url && Object.keys(setHeaders).length === 0) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        url,
        setHeaders,
      })
    );
  }
}
